import React, {
    useState, useEffect
} from 'react';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select, Button } from 'antd';
import { DatePicker, TimePicker, Space } from 'antd'
import { Config } from "../../config/config";
import { useNavigate } from 'react-router-dom';
import { SavePmpSchedule, doGetPMPList, SavePmpReSchedule, PMPList, GetTechnicianPMPList, AddTechnicianData, ClearData, DownloadPMPReports } from './actions/pmpService';
import { Calendar } from 'antd';
import { useDispatch, useSelector } from 'react-redux'
import { Popover } from 'antd';
import Cookie from 'js-cookie';
import moment from 'moment'
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { acceptPlanner } from './actions/pmpService';
import Modal from 'antd/lib/modal/Modal';
import Spinner from "../../UIComponents/Spinner/Spinner";
import * as XLSX from 'xlsx';
import LZString from 'lz-string';
import dayjs from 'dayjs';
const { Option } = Select;



function PMPVendorList() {
    const title = "Preventive Maintenance Planner List";
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    let userID = user['userId']
    const config = JSON.parse(Config);
    const apiInterface =config["api1"]
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const pmpData = useSelector(state => state.pmpList)
    const TechnicianDetails = useSelector(state => state?.pmpList?.TechnicianDetails?.TechnicianList)
    const contractNameList = useSelector(state => state?.pmpList?.PMPDetails?.ContractNameList)
    const storeList = useSelector(state => state?.pmpList?.PMPDetails?.StoreList)
    const subCategoryList = useSelector(state => state?.pmpList?.PMPDetails?.SubCategoryList)
    const assetList = useSelector(state => state?.pmpList?.PMPDetails?.AssetList)
    const pmpList = useSelector(state => state?.pmpList?.PMPDetails?.PMPList)
    const existingPMPList = useSelector(state => state?.pmpList?.PMPDetails?.ExistingPMPList)
    const pmpHistory = useSelector(state => state?.pmpList?.PMPDetails?.PMPHistory)
    const PMPReportData = useSelector(state=> state?.pmpList?.PMPReportData?.PMPReportData)
    const SubCategoryList = useSelector(state=> state?.pmpList?.PMPReportData?.SubCategoryList)
    const [reportTableData, setReportTableData] = useState([])
    const [reportSubId,setReportSubId] = useState(null);
    const [pmpListTableData,setPmpListTableData] = useState([])
    const [isPMPScheduleOpen, setIsPMPScheduleOpen] = useState(false);
    const [isAddTechnicianOpen, setIsAddTechnicianOpen] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [allowSchedule, setAllowSchedule] = useState('')
    const [PMPStatus, setPMPStatus] = useState('')
    const [isSubmit, setIsSubmit] = useState(false)
    const TotalPMPList = useSelector(state=>state?.pmpList?.PMPDetails?.GroupPMPList)
    const [GroupPMPList,setGroupPMPList] = useState(TotalPMPList)    
    const [calanderDate, setCalanderDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [excelDate, setExcelDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [downloadPdfPath,setDownloadPdfPath] = useState('')
    const [isSelectedDate,setIsSelectedDate] = useState(false)
    const [selectedDateData, setSelectedDateData] = useState([])
    const [selectedDate, setSelectedDate] = useState('')
    const [addTechnician, setAddTechnician] = useState({
        fedid:userID,
        technician_name:'',
        technician_email:'',
        technician_mobile:'',
    })
    const [scheduleData, setScheduleData] = useState({
        fedid: userID,
        storeid: 0,
        contractnameid: 0,
        subcategoryids: [],
        assetids: [],
        pmptype: 0,
        pmpstartdate: dayjs().format("YYYY-MM-DD hh:mm:ss"),
        comments: '',
        technician: '',
        assetListForSubCategory:[],
        pmpid: '',
    })
    const [isReportGenerator, setIsReportGenerator] = useState(false)
    const [storeId, setStoreId] = useState(null)
    const [isSchedule, setIsSchedule] = useState(false)
    const [isVendorAccepted,setIsVendorAccepted] = useState(false)
    const [isVendorRescheduled,setIsVendorRescheduled] = useState(false)
    const [isSOMRescheduled,setIsSOMRescheduled] = useState(false)
    const [isSOMCancelled,setIsSOMCancelled] = useState(false)
    const [isPartial,setIsPartial] = useState(false)
    const [isCompleted,setIsCompleted] = useState(false)
    const _doNavToAddTechnician = () => {
        dispatch(GetTechnicianPMPList())
        setIsAddTechnicianOpen(true);
        setIsModalVisible(true)
    }
    const _doCloseTechnicianModal = () => {
        setIsModalVisible(false);
        setIsAddTechnicianOpen(false);
        setIsSubmit(false)
    };
    const handleTechnician = (e) =>{
        setIsSubmit(true);
        e.preventDefault();
        if(addTechnician.technician_name == "")return;
        else if (addTechnician.technician_email == "" || !validateEmail(addTechnician.technician_email))return;
        else if ((`${addTechnician.technician_mobile}`.length < 10 || `${addTechnician.technician_mobile}`.length > 10)) return;
        console.log(addTechnician,'addTechnicianData')
        // addTechnician.technician_mobile = Number(addTechnician.technician_mobile);
        dispatch(AddTechnicianData(addTechnician));
        setAddTechnician({
            fedid:userID,
            technician_name:'',
            technician_email:'',
            technician_mobile:'',
        })
        _doCloseTechnicianModal();
        setIsSubmit(false);
    }
    const _doNavToAddPlanner = () => {
        setIsPMPScheduleOpen(true);
        setIsEdit(true)
    }
    const _doNavToAddPlanner1 = () => {
        setIsPMPScheduleOpen(true);
        setIsEdit(false)
    }
    const _doNavToPMPVendorReschedule = () => {
        // localStorage.setItem('rescheduleData', JSON.stringify(scheduleData))
        // navigate("/PMPVendorReschedule");
        // navigate({
        //     pathname: '/PMPVendorReschedule',
        //     state: {scheduleData }
        // });
        navigate('/PMPVendorReschedule', { state: { scheduleData } });
    }
    const _doNavToPMPVendorAccept = () => {
        navigate("/PMPVendorAccept");
    }
    const _doNavToPMPVendorList = () => {
        navigate("/PMPVendorList");
    }
    const _doNavToEditPlanner = () => {
        setIsPMPScheduleOpen(true);
        setIsEdit(true)
    }
    const _doNavToCancelPlanner = () => {
        navigate("/PMPScheduleCancel");
    }
    const _doCloseModal = () => {
        setIsPMPScheduleOpen(false);
        setIsEdit(true)
    }
    // console.log(scheduleData,'scheduleData');
    const validateEmail = (email) => {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
    
    const confirmChecking = (item) => {console.log(item,'item')
        _doNavToEditPlanner();
        setScheduleData({
            ...scheduleData,
            storeid: item.store_id,
            contractnameid: item.contract_id,
            subcategoryids: [item.sub_category_id],
            assetids: JSON.parse(item.assetlist),
            pmptype: item?.pmp_type,
            pmpstartdate: item?.pmp_start_date,
            comments: item?.som_comments,
            technician: item?.technician == 0 ? '':item?.technician,
            assetListForSubCategory:item?.assetlist_for_subcategory.length ==1 ?[Number(item?.assetlist_for_subcategory.length)]:Array.from(item.assetlist_for_subcategory.split(','),Number) ,
            pmpid: getPMPId(item)
        })
        // console.log(scheduleData,'scheduleData');
        setAllowSchedule(item.allow_reshedule);
        setPMPStatus(item.pmp_status);

    }
    // console.log(scheduleData, 'scheduleData')
    // console.log(PMPStatus, 'allowschedule')
    const getPMPId = (item) =>{
        console.log(item,'scheduleData inside getPMPId')
        const {sub_category_id, contract_id, pmp_start_date, store_id} = item

        let filterPmpId = pmpList.filter(ele=> ele.sub_category_id == sub_category_id && ele.contract_id == contract_id && ele.pmp_start_date == pmp_start_date && ele.store_id == store_id )
        console.log(filterPmpId,'filterPmpId')
        setDownloadPdfPath(filterPmpId.length >0 ? filterPmpId[0].pdf_path:"")
        return filterPmpId[0].id

    }
    const handleSubmit = () => {
        setIsSubmit(true);
        // if (scheduleData.technician == '') return;
        if (scheduleData.comments == '') return;
        else if(scheduleData.technician == '')return;

        _doCloseModal();
        const acceptPlannerData = {
            fedid: userID,
            pmpid: scheduleData.pmpid,
            resheduled_type: 0,
            comments: scheduleData.comments,
            technician: scheduleData.technician
        }
        setIsSubmit(false)
        dispatch(acceptPlanner(acceptPlannerData));
    }

    useEffect(() => {
        dispatch(doGetPMPList())
        dispatch(GetTechnicianPMPList())
        return()=>{
            dispatch(ClearData())
        }
    }, [])
    useEffect(()=>{
        console.log(PMPReportData,'PMPReportData')
        setReportTableData(PMPReportData)
    },[PMPReportData])
    const handleReportTableData = () =>{
        if(reportSubId==null || typeof(reportSubId) =="undefined"){
            setReportTableData(PMPReportData)
        }
        else{
            let data = [];
            let fetchedData = PMPReportData?.filter(ele=>ele.sub_category_id == reportSubId).map(e=>data.push(e))
            setReportTableData(data)
        }
    }
    const _doCellDataRender = (value) => {
        const listData = _doGetCellData(value);
        const tableData = pmpHistory?.filter(ele => ele.pmp_id == listData?.map(element => element.id))
        return (
            <ul className="m-calendar__data">
                {listData?.map((item, index) => (
                    // <Popover key={index} placement="right" content={
                    //     <div className="m-popover_info">
                    //         <div className="m-popover-header">
                    //             <span className="m-header_left"></span>
                    //             <span className="m-header-right">{item.name}</span>
                    //         </div>
                    //         <div className="m-popover-content">
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-cogs"></i>
                    //                 <span className="content_info">{item.name}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-calendar-o"></i>
                    //                 <span className="content_info">{item.pmp_start_date}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-check"></i>
                    //                 <span className="content_info">{item.pmp_status}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fas fa-store"></i>
                    //                 <span className="content_info">{item.store_name}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-user-o"></i>
                    //                 <span className="content_info">{item.vendor_company_name}</span>
                    //             </div>
                    //             <div className="popover_content_info">
                    //                 <i className="fa fa-user-o"></i>
                    //                 <span className="content_info">{item.technician}</span>
                    //             </div>
                    //         </div>
                    //         <div className="m-popover-content">
                    //             {tableData.length != 0 &&
                    //                 <table className='table table-bordered table-striped'>
                    //                     <thead className='bg-primary'>
                    //                         <tr>
                    //                             <td>pmp startDate </td>
                    //                             <td>pmp reschedule date </td>
                    //                             <td>pmp comments </td>
                    //                             <td>created by</td>
                    //                         </tr>
                    //                     </thead>
                    //                     <tbody>
                    //                         {
                    //                             tableData?.map((ele, index) =>
                    //                                 <tr key={index}>
                    //                                     <td>{ele.pmp_start_date.slice(0, 10)}</td>
                    //                                     <td>{ele.pmp_reschedules_date.slice(0, 10)}</td>
                    //                                     <td>{ele.pmp_comments}</td>
                    //                                     <td>{ele.created_by}</td>
                    //                                 </tr>
                    //                             )
                    //                         }
                    //                     </tbody>
                    //                 </table>}
                    //         </div>
                    //     </div>
                    // }>
                        <li 
                        className={item.name}
                        key={index} value={item.pmp_status}
                        style={{ color: `${item.pmp_status_color}` }}
                        // onClick={() => confirmChecking(item)}
                        >
                            {item.name}
                        </li>
                    // {/* </Popover> */}
                ))}
            </ul>
        );
    }
    useEffect(()=>{
        setPmpListTableData(TotalPMPList);
        setGroupPMPList(TotalPMPList)
    },[TotalPMPList])
    const _doGetCellData = (value) => {
        const date = value.format('YYYY-MM-DD');
        let listData = pmpListTableData?.filter(ele=> ele?.pmp_start_date?.slice(0,10)===date && calanderDate.slice(0,7)== date.slice(0,7))
        if(typeof(listData) != 'undefined'){
            if(listData.length !=0){
                // console.log(listData,'listData')
            } 
        }
        return listData;
    }
    const _doSelectVender = () => {
    }
    // const GetExcelData = (value) => {

    //     const date = value.format('YYYY-MM-DD');
    //     let listData = pmpList?.filter(ele => ele?.pmp_start_date?.slice(0, 10) === date)
    //     return listData;
    // }
    // console.log(scheduleData,'scheduleData')

    const GetExcelData = (value) => {
        const date = value.format('YYYY-MM-DD');
        setExcelDate(date);
        // let listData = pmpList?.filter(ele => ele?.pmp_start_date?.slice(0, 10) === date)
    }
    const onSelect=(value)=>{
        const ExcelDate = GetExcelData(value);
        let listData = _doGetCellData(value)
        setSelectedDateData(listData)
        setIsSelectedDate(true)
        setSelectedDate(value.format('YYYY-MM-DD'))
    }
    // $('.ant-picker-cell-selected').parent('tr').css({"maxHeight":"200px"})
    
    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();
        multiDataSet.forEach((data, index) => {
          const ws = XLSX.utils.json_to_sheet(data.dataSet);
          XLSX.utils.book_append_sheet(wb, ws, data.name || `Sheet${index + 1}`);
        });
        XLSX.writeFile(wb, 'PMPList.xlsx');
    };
    
    // const ExcelDate = value.format('YYYY-MM-DD');

    // const newList=GetExcelData(pmpList)

    const multiDataSet = [
        {
            
          columns: [
            { title: "Asset Name",width: { wpx: 90 } } ,//pixels width
            { title: "Allow Reshedule",width: { wpx: 90 } }, //char width
            { title: "Asset ID",  width: { wpx: 90 }},
            { title: "Asset List", width: { wpx: 90 } },
            { title: "Checkllist Score", width: { wpx: 90 } },
            { title: "Contract ID", width: { wpx: 90 } },
            { title: "ID", width: { wpx: 90 } },
            { title: "Name", width: { wpx: 90 } },
            { title: "PMP Start Date", width: { wpx: 90 } },
            { title: "PMP Status", width: { wpx: 90 } },
            { title: "PMP Type", width: { wpx: 90 } }
          ],
          data:pmpList?.map((data)=>[
              {value:data.asset_name,},
              {value:data.allow_reshedule,},
              {value:data.asset_id,},
              {value:data.assetlist,},
              {value:data.checkllist_score,},
              {value:data.contract_id,},
              {value:data.id,},
              {value:data.name,},
              {value:data.pmp_start_date,},
              {value:data.pmp_status,style: {
                fill: { patternType: "solid", fgColor: { rgb: data.pmp_status_color.slice(1) } }
              }},
              {value:data.pmp_type,}
            
          ])
        }
    ];
    // const [isSchedule, setIsSchedule] = useState(false)
    // const [isVendorAccepted,setIsVendorAccepted] = useState(false)
    // const [isVendorRescheduled,setIsVendorRescheduled] = useState(false)
    // const [isSOMRescheduled,setIsSOMRescheduled] = useState(false)
    // const [isSOMCancelled,setIsSOMCancelled] = useState(false)
    // const [isPartial,setIsPartial] = useState(false)
    // const [isCompleted,setIsCompleted] = useState(false)
    const handleLegends=(value) =>{
        if(value=='Scheduled'){
            setIsSchedule(true)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'Vendor Accepted'){
            setIsSchedule(false)
            setIsVendorAccepted(true);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'Vendor Rescheduled'){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(true)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'SOM Rescheduled' ){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(true)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'SOM Cancelled' ){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(true)
            setIsPartial(false)
            setIsCompleted(false)
        }
        else if(value == 'Partial' ){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(true)
            setIsCompleted(false)
        }
        else if(value == 'Completed' ){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(true)
        }
        else if(value == 'All'){
            setIsSchedule(false)
            setIsVendorAccepted(false);
            setIsVendorRescheduled(false)
            setIsSOMRescheduled(false)
            setIsSOMCancelled(false)
            setIsPartial(false)
            setIsCompleted(false)
            setPmpListTableData(GroupPMPList)
        }

    }
    const handleCount =(value) => {
        if(value !='All'){
            let data =GroupPMPList?.filter(ele=> ele.pmp_status ===value && calanderDate.slice(0,7)==ele.pmp_start_date.slice(0,7));
            return data ? data?.length :0
        }
        else{
            return GroupPMPList? GroupPMPList?.filter(ele=>ele.pmp_start_date.slice(0,7) == calanderDate.slice(0,7)).length :0
        }
    }
    useEffect(()=>{
        if(isSchedule && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Scheduled")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isVendorRescheduled && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Vendor Rescheduled")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isVendorAccepted && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Vendor Accepted")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isSOMRescheduled && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "SOM Rescheduled")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isSOMCancelled && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "SOM Cancelled")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isPartial && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Partial")
            setPmpListTableData(info)
            console.log(info)
        }
        else if(isCompleted && typeof(GroupPMPList) != 'undefined'){
            const info =GroupPMPList.filter(ele=>ele.pmp_status === "Completed")
            setPmpListTableData(info)
            console.log(info)
        }
    },[isSchedule,isVendorRescheduled, isVendorAccepted, isSOMRescheduled, isSOMCancelled, isPartial, isCompleted ])
    
    function onPanelChange(value, mode) {
        setCalanderDate(value.format('YYYY-MM-DD'))
        console.log(value.format('YYYY-MM-DD'), mode);
        setIsSchedule(false)
        setIsVendorAccepted(false);
        setIsVendorRescheduled(false)
        setIsSOMRescheduled(false)
        setIsSOMCancelled(false)
        setIsPartial(false)
        setIsCompleted(false)
        setPmpListTableData(GroupPMPList)
    }
    const downloadReport = ()=>{
        // window.location.href = apiInterface+`/downloadimages?Image_id=${downloadPdfPath}`
        window.location.href = `${apiInterface}/downloadfiles?Image_id=${downloadPdfPath}&token_id=${Cookie.get('token')}`
    }
    // const [isReportGenerator, setIsReportGenerator] = useState(false)
    // const [storeId, setStoreId] = useState(null)
    const handleSearch = () => {
        console.log(storeId,'storeId')
        if(storeId !=null && typeof(storeId) !='undefined'){
            console.log('inside if')
            let data = TotalPMPList?.filter(ele=>ele.store_id == storeId)
            setGroupPMPList(data)
            setPmpListTableData(data)
        }
        else if(typeof(storeId) == "undefined" || storeId == null){
            console.log('inside else if')
            setGroupPMPList(TotalPMPList)
            setPmpListTableData(TotalPMPList)
        }
    }

    const [reportData,setReportData] =useState({
        startDate:null,
        endDate:null,
        storeId:null
    })
    const handleSearchReport = ()=>{
        setIsSubmit(true)
        if(reportData.storeId==null) return
        else if(reportData.startDate == null|| reportData.startDate =='') return
        else if(reportData.endDate == null || reportData.endDate == '') return
        console.log(reportData,'reportData')
        const jsonData = {
            start_date:reportData.startDate,
            end_date:reportData.endDate,
            store_id:reportData.storeId,
        }
        dispatch(DownloadPMPReports(jsonData))
    }
    const handleReportGenerator = () => {
        setIsReportGenerator(true)
        setIsModalVisible(true)
    }
    const handleCloseReportGenerator = () => {
        setIsSubmit(false)
        setReportData({...reportData,storeId:null,startDate:null,endDate:null})
        setReportSubId(null)
        dispatch(ClearData())
        setIsModalVisible(false);
        setIsReportGenerator(false);
    };
    const handleDownloadReport = (data) => {
        // window.location.href = `${apiInterface}/downloadimages?Image_id=${data.pdf_path}`
        if(data.pdf_path!=""  && data.pdf_path.includes('.pdf')==true){
            // window.location.href = `${apiInterface}/downloadimages?Image_id=${data.pdf_path}`
            window.location.href = `${apiInterface}/downloadfiles?Image_id=${data.pdf_path}&token_id=${Cookie.get('token')}`
        }
    }
    const  disabledDate = (current) => {
        // let date = moment().add(1,'days')
        // return current && current > dayjs(date,'DD-MM-YYYY').startOf('day');
        let date = dayjs().add(1, 'day').startOf('day');
  return current && current > date;
    }
    const closeDateListModal = () =>{
        setIsSelectedDate(false)
    }
    const isItGreaterDate = ()=>{
        // const takenDate =moment(selectedDate);
        // const presentDate = moment();
        // return presentDate.diff(takenDate, 'days')>1?false:true
        const takenDate = dayjs(selectedDate);
        const presentDate = dayjs();
        return presentDate.diff(takenDate, 'day') >1?false:true
    }
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />{pmpData.modalOpen ? (
                <MessageBox
                    message={pmpData.message}
                    // signout={"false"}
                    onClose={() => {
                        dispatch(doGetPMPList())
                        dispatch(GetTechnicianPMPList())
                        dispatch(PMPList(true))
                    }}

                />

            ) : null}
            {pmpData?.loading && 
                <Spinner />}
            <div className='content-wrapper'>
                {
                    isAddTechnicianOpen === true ?
                        "" : <div className="m-btn-block">
                            <div className="m-btn-block__container">
                                <div className="m-btn-block__icon">
                                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                </div>
                                <div className="m-btn-block__btns">
                                    <button type='submit' onClick={_doNavToAddTechnician} className='btn btn-secondary deca-btn-yellow'>Add Technician</button>
                                </div>
                            </div>
                        </div>
                }

                <section className='content'>
                    {/* <div className="m-page__button">
                            <button type='submit' onClick={this._doNavToCancelPlanner} className='btn btn-secondary deca-btn-yellow color-red'>Cancel PMP</button>
                            <button type='submit' onClick={this._doNavToAddPlanner} className='btn btn-secondary deca-btn-yellow'>Schedule PMP</button>
                        </div> */}
                    <div className="m-panel mt-10">
                        <div className="m-pane__body p10">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className='form-group'>
                                        <label htmlFor='exampleInput'>Select store</label>
                                        <Select className="form-control"
                                            allowClear={true}
                                            showSearch
                                            onChange={(value)=>setStoreId(value)}
                                            value={storeId}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        > {
                                            storeList?.map(((item, index) =>
                                                    <Option key={index} value={item.store_id}>{item.store_name}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-1 btn-no-lbl">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow' onClick={handleSearch}>
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>
                                <div className="col-md-3 btn-no-lbl">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportGenerator}>
                                        View Report
                                    </button>
                                </div>

                                <div className="col-md-2 btn-no-lbl">
                                <button
                                className='btn btn-secondary deca-btn-yellow'
                                onClick={exportToExcel}
                                >
                                Export to Excel
                                </button>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                    <div className='row'>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#808080'}}><span className='dot' style={{backgroundColor:'#808080'}}></span> <button onClick={()=>handleLegends('Scheduled')}>Scheduled-<span>{handleCount('Scheduled')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#0000FF'}}><span className='dot' style={{backgroundColor:'#0000FF'}}></span> <button onClick={()=>handleLegends('Vendor Accepted')}>Vendor Accepted-<span>{handleCount('Vendor Accepted')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#ECA0A8'}}><span className='dot' style={{backgroundColor:'#ECA0A8'}}></span> <button onClick={()=>handleLegends('Vendor Rescheduled')}>Vendor Rescheduled-<span>{handleCount('Vendor Rescheduled')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#ECA0A8'}}><span className='dot' style={{backgroundColor:'#ECA0A8'}}></span><button onClick={()=>handleLegends('SOM Rescheduled')}>SOM Rescheduled-<span>{handleCount('SOM Rescheduled')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#FF0000'}}><span className='dot' style={{backgroundColor:'#FF0000'}}></span> <button onClick={()=>handleLegends('SOM Cancelled')}>SOM Cancelled-<span>{handleCount('SOM Cancelled')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#008000'}}><span className='dot' style={{backgroundColor:'#008000'}}></span> <button onClick={()=>handleLegends('Partial')}>Partial-<span>{handleCount('Partial')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#008000'}}><span className='dot' style={{backgroundColor:'#008000'}}></span> <button onClick={()=>handleLegends('Completed')}>Completed-<span>{handleCount('Completed')}</span></button></span>
                              </div>
                            </div>
                            <div className='col-md-3'>
                              <div className='color-status'>
                                <span className='color-status-indicator' style={{color:'#008000'}}><span className='dot' style={{backgroundColor:'#000'}}></span> <button onClick={()=>handleLegends('All')}>All-<span>{handleCount('All')}</span></button></span>
                              </div>
                            </div>
                    </div>
                        <div className="m-panel__body bg-dark p10">

                            <div className="m-calendar">
                                <Calendar cellRender={_doCellDataRender} mode='month'  onSelect={onSelect} onPanelChange={onPanelChange} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
            {
                isPMPScheduleOpen === true ?

                    <div className="m-modal">
                        <div className="m-modal__container">
                            <div className="m-modal__header">
                                {/* {
                                        isEdit == true ?
                                        <h5 className="m-modal__title">Accepted Edit - PMP By Vendor</h5>
                                        : <h5 className="m-modal__title">Confirmation - PMP By Vendor</h5>
                                    } */}
                                {
                                    allowSchedule == 1 ? <h5 className="m-modal__title">Confirmation - PMP By Vendor</h5> :
                                        PMPStatus == 'SOM Cancelled' && allowSchedule == 0 ? <h5 className="m-modal__title">Cancelled - PMP By SOM</h5> :
                                        PMPStatus == 'Vendor Accepted' && allowSchedule == 0 ? <h5 className="m-modal__title">Accepted - PMP By Vendor</h5>:
                                        PMPStatus == 'Completed' && allowSchedule == 0 ?  <h5 className="m-modal__title">Completed</h5>:
                                        PMPStatus == "Scheduled" && allowSchedule == 0 ?  <h5 className="m-modal__title">Scheduled </h5>:
                                        PMPStatus == "Partial" && allowSchedule == 0 ?  <h5 className="m-modal__title">Partial</h5>:
                                        PMPStatus == "SOM Rescheduled" && <h5 className="m-modal__title">SOM Rescheduled</h5>

                                }
                                <span className="m-modal__close" onClick={_doCloseModal}>
                                    <i className="fa fa-close"></i>
                                </span>
                            </div>
                            <div className="m-modal__body">
                                <div className="row">
                                {downloadPdfPath.includes('.pdf') &&
                                <div className="col-md-12 text-right">
                                    <span className="text-primary" style={{cursor:'pointer'}} onClick={()=>downloadReport()}>Download Report</span>
                                </div>}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Contract*</label>
                                            <Select className="form-control" disabled
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                value={scheduleData?.contractnameid}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {contractNameList?.map((element, index) => {
                                                    return (
                                                        <Option key={index} value={element.id} >{element.contract_name}</Option>
                                                    )
                                                })}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Store*</label>
                                            <Select className="form-control multiselect"
                                                showSearch
                                                disabled
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                value={scheduleData?.storeid}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {
                                                    storeList?.map((element, index) => {
                                                        return (
                                                            <Option key={index} value={element.store_id}>{element.store_name}</Option>
                                                        )
                                                    })

                                                }
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group select_h150">
                                            <label htmlFor='exampleInput'>Asset sub category*</label>
                                            <Select className="form-control multiselect" mode="multiple" disabled
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                value={scheduleData?.subcategoryids}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            > {
                                                    subCategoryList?.map(((element, index) =>
                                                        <Option key={index} value={element.id}>{element.name}</Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group select_h150">
                                            <label htmlFor='exampleInput'>Assets*</label>
                                            <Select className="form-control multiselect" mode="multiple" disabled
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                value={scheduleData?.assetListForSubCategory}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            > {
                                                    assetList?.map(((element, index) =>
                                                        <Option key={index} value={element.asset_id}>{element.asset_name}</Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>PM type*</label>
                                            <Select className="form-control" disabled
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                value={scheduleData.pmptype}
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value='1'>Bi-Weekly</Option>
                                                <Option value='2'>Monthly</Option>
                                                <Option value='3'>Quaterly</Option>
                                                <Option value='4'>Yearly</Option>
                                                <Option value='5'>One Time</Option>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Proposed Date & Time*</label>
                                            <DatePicker showTime={{ format: 'hh:mm a' }} use12Hours
                                                format="YYYY-MM-DD hh:mm:ss a"
                                                defaultValue={scheduleData?.pmpstartdate ? dayjs(scheduleData?.pmpstartdate, "YYYY-MM-DD hh:mm:ss") : ''}
                                                className="form-control" disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Comment*</label>
                                            <input
                                                type="text"
                                                maxLength="1000"
                                                className="form-control"
                                                value={scheduleData?.comments}
                                                onChange={(e) => setScheduleData({ ...scheduleData, comments: e.target.value.replace(/[^\w\s]/gi, "") })}
                                                disabled={allowSchedule == 0}
                                            />
                                            {scheduleData?.comments =='' && isSubmit==true&& <span className='text-danger'>Please Enter comments</span>}
                                        </div>
                                    </div>
                                    {
                                        isEdit === true ?
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInput">Assign Technician</label>
                                                    <Select className="form-control"
                                                        placeholder="-- Please Select --"
                                                        value={scheduleData?.technician}
                                                        onChange={(value) => setScheduleData({ ...scheduleData, technician: value })}
                                                        // disabled={allowSchedule == 0}
                                                        disabled ={(PMPStatus==="Vendor Accepted"|| allowSchedule==1)&& isItGreaterDate()? false:true}
                                                    >
                                                        {
                                                            TechnicianDetails?.map((element,index)=>{
                                                                return(
                                                                    <Option key={index} value={element.technician_id}>{element.technician_name}</Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                    {scheduleData?.technician =='' && isSubmit==true&& <span className='text-danger'>Please Select Technician</span>}

                                                    {(allowSchedule != 0 ||PMPStatus === "Vendor Accepted")&& isItGreaterDate()&& <h5 className="text-primary" onClick={_doNavToAddTechnician} style={{cursor:'pointer'}} >Add Technician</h5>}
                                                </div>
                                            </div> : ""
                                    }
                                    <div className="col-md-12 text-center">
                                        <div className="m-page__button top-space text-center">

                                            {
                                                ((allowSchedule == 1 ||PMPStatus === "Vendor Accepted")&& isItGreaterDate())&&
                                                <>
                                                    <button type='button' className='btn muted-button  deca-btn-yellow' onClick={handleSubmit}>Accept</button>
                                                    {PMPStatus != "Vendor Accepted" &&<button type='button' onClick={_doNavToPMPVendorReschedule} className='btn btn-secondary deca-btn-yellow'>Reshedule</button>}
                                                </>
                                                // : <button type='button' onClick={_doNavToPMPVendorAccept} className='btn btn-secondary deca-btn-yellow color-green'>Accept</button>
                                            }
                                            {/* {!this.state.IsEdit?<button type='button' onClick={_doNavToPMPVendorAccept} className='btn btn-secondary deca-btn-yellow color-green'>Accept</button>:null} */}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    : false
            }
            {/* {
                isPMPScheduleOpen === true ?
                    <div className="overlay" onClick={_doCloseModal}>

                    </div>
                    : false
            } */}
            {
                isAddTechnicianOpen === true ?
                    <Modal title="Technicians" width={1000} closeIcon open={isModalVisible}
                        footer={[
                            <Button key="back" onClick={_doCloseTechnicianModal}>
                                Cancel
                            </Button>,
                            <Button key="submit" type="primary" onClick={handleTechnician}>
                                Submit
                            </Button>,
                        ]}>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='table'>
                                    <table className='table table-striped table-bordered'>
                                        <thead className='bg-primary'>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Login Id</th>
                                                <th>Technician Name</th>
                                                <th>Email Address</th>
                                                <th>Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody className='text-center'>
                                            
                                            {
                                                TechnicianDetails?.map((ele,index)=>{
                                                    return(
                                                        <tr key = {index}>
                                                            <td>{index+1}</td>
                                                            <td>{ele.technician_id}</td>
                                                            <td>{ele.technician_name}</td>
                                                            <td>{ele.technician_email}</td>
                                                            <td>{ele.technician_mobile}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='form-group'>
                                    <label className='custom-label'>Technician Name</label>
                                    <input type="text" className='form-control' maxLength="100" onChange={(e)=> setAddTechnician({...addTechnician,technician_name:e.target.value.replace(/[^\w\s]/gi, "")})} value={addTechnician.technician_name}/>
                                    {addTechnician.technician_name == '' && isSubmit == true && <span style={{color:'red'}}>Please Enter Technician name</span>}
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='form-group'>
                                    <label className='custom-label'>Email Address</label>
                                    <input type="email" className='form-control' maxLength="100"  onChange={(e)=> setAddTechnician({...addTechnician,technician_email:e.target.value.replace(/[^a-zA-Z0-9_@. ]/gi, "")})} value={addTechnician.technician_email}/>
                                    {addTechnician.technician_email == '' && isSubmit == true && <span style={{color:'red'}}>Please Enter Technician email</span>}
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='form-group'>
                                    <label className='custom-label'>Mobile Number</label>
                                    <input type="text" className='form-control'maxLength='10' onChange={e => setAddTechnician({ ...addTechnician, technician_mobile: e.target.value.replace(/[^0-9]/g, '') })} value={addTechnician.technician_mobile}/>
                                    {(addTechnician.technician_mobile.length<10) && isSubmit == true && <span style={{color:'red'}}>Please Enter Technician Mobile number</span>}
                                </div>
                            </div>
                        </div>
                    </Modal>
                    : false
            }

            {/* {
                isAddTechnicianOpen === true ?
                    <div className="overlay" onClick={_doCloseModal}>

                    </div>
                    : false
            } */}
            {
                isReportGenerator === true ?
                    <Modal title="Download Report" width={1000} closeIcon open={isModalVisible}
                        footer={[
                            <Button key="back" onClick={handleCloseReportGenerator}>
                                Cancel
                            </Button>
                        ]}>
                          <div className="row">
                          <div className="col-md-3">
                            <div className='form-group'>
                              <label htmlFor='exampleInput'>Select Store</label>
                              <Select className="form-control"
                                showSearch
                                onChange={(value)=>setReportData({...reportData,storeId:value})}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                // value={storeId}
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              > {
                                storeList?.map((element,index)=>{
                                    return(
                                        <Option key ={index} value={element.store_id}>{element.store_name}</Option>
                                    )
                                })
                            }
                              </Select>
                              {reportData.storeId == null && isSubmit == true && <span className='text-danger'>Please Select Store</span>}
                            </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                  <label htmlFor='exampleInput'>Start Date*</label>
                                  <DatePicker className="form-control" format={'DD-MM-YYYY'} disabledDate={disabledDate} onChange={(date, dateString) => setReportData({...reportData,startDate:dateString})}/>
                                  {(reportData.startDate == null || reportData.startDate == '') && isSubmit == true && <span className='text-danger'>Please Select Start Date</span>}
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                  <label htmlFor='exampleInput'>End Date*</label>
                                  <DatePicker className="form-control" format={'DD-MM-YYYY'} disabledDate={disabledDate} onChange={(date, dateString) => setReportData({...reportData,endDate:dateString})}/>
                                  {(reportData.endDate == null || reportData.endDate == '') && isSubmit == true && <span className='text-danger'>Please Select End Date</span>}
                              </div>
                          </div>
  
                          <div className="col-md-1 btn-no-lbl">
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={()=>handleSearchReport()}>
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                      </div>
                        <div className="row">
                          <div className="col-md-3">
                              <div className='form-group'>
                                <label htmlFor='exampleInput'>Select Subcategory</label>
                                <Select className="form-control"
                                  showSearch
                                  onChange={(value)=>setReportSubId(value)}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  allowClear={true}
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                  SubCategoryList?.map(((item,index) =>
                                      <Option key={index} value={item.sub_category_id}>{item.sub_category_name}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                          </div>
                          <div className="col-md-1 btn-no-lbl">
                            <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'  onClick={handleReportTableData}>
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='table'>
                                    <table className='table table-striped table-bordered'>
                                        <thead className='bg-primary'>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Subcategory Name</th>
                                                <th>Asset Name</th>
                                                <th>Start Date</th>
                                                <th>Vendor Name</th>
                                                <th>Technician Name</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className='text-center'>
                                            
                                            {
                                                reportTableData?.map((ele,index)=>{
                                                    return(
                                                        <tr key = {index}>
                                                            <td>{index+1}</td>
                                                            <td>{ele.sub_category_name}</td>
                                                            <td>{ele.asset_name}</td>
                                                            <td>{ele.pmp_start_date}</td>
                                                            <td>{ele.vendor_company_name}</td>
                                                            <td>{ele.technician_name}</td>
                                                            {/* <td onClick={()=>handleDownloadReport(ele)} style={{cursor:'pointer'}}>{ele.pdf_path.includes('.pdf')&&<i className="fa fa-download"/>}</td> */}
                                                            <td onClick={()=>handleDownloadReport(ele)} style={ele.pdf_path.includes('.pdf')? {cursor:'pointer'}:{cursor:'default'}}>{ele.pdf_path.includes('.pdf')&&<i className="fa fa-download"/>}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </Modal>
                    : false
            }
            {
                isSelectedDate &&
                <div className='datapopup'>
                    <div className="datapopup-header">
                        <h1>{selectedDate}</h1>
                        <span className="m-modal__close" onClick={closeDateListModal}>
                            <i className="fa fa-close"></i>
                        </span>
                    </div>
                    <div className='datapopup-body'>
                        <ul className='m-calendar__data'>
                            {selectedDateData?.map((item,index)=>(
                                <li className={item.name} key={index} value={item.pmp_status} style={{ color: `${item.pmp_status_color}` }} onClick={() => confirmChecking(item)}>
                                {item.name}
                            </li>
                            ))
                            }
                        </ul>
                    </div>
                </div>
            }
        </div>
    )
}

export default PMPVendorList
